'use client';

import { memo } from 'react';

import { HorizontalWrapper } from '@web/molecules/VideoPlayer/atoms/HorizontalWrapper';
import { VideoPlayerFactory } from '@web/molecules/VideoPlayer/organisms/VideoPlayerFactory';

import { type VideoPlayerProps } from './VideoPlayer.types';

import styles from './VideoPlayer.module.scss';

const VideoPlayerComponent = (props: VideoPlayerProps) => {
    return (
        <VideoPlayerFactory
            {...props}
            PlayerWrapper={HorizontalWrapper}
            sectionClassName={styles['videoplayer-horizontal']}
        />
    );
};

VideoPlayerComponent.displayName = 'VideoPlayer';

export const VideoPlayer = memo(VideoPlayerComponent);
